<template>
  <div class="list_sidebar dim_sidebar">
    <div v-if="isLoggedIn">
      <div class="user-name">
        {{ account.firstName }} {{ account.lastName }}
      </div>
      <v-list  dark nav dense>
        <v-list-item to="/home">
          <v-list-item-icon>
            <v-icon>mdi-home-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>
        <v-list-item to="/mydata">
          <v-list-item-icon>
            <v-icon>mdi-account-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>I miei dati</v-list-item-title>
        </v-list-item>
        <v-list-item to="/payrolls">
          <v-list-item-icon>
            <v-badge
              color="red"
              :content="bpNonLetti"
              :value="bpNonLetti && bpNonLetti > 0"
              overlap
            >
              <v-icon>mdi-text-box-outline</v-icon>
            </v-badge>
          </v-list-item-icon>
          <v-list-item-title>Buste paga</v-list-item-title>
        </v-list-item>
        <v-list-item to="/myrequests">
          <v-list-item-icon>
            <v-icon>mdi-calendar-text-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Richieste</v-list-item-title>
        </v-list-item>
        <v-list-item to="/cuds">
          <v-list-item-icon>
            <v-badge
              color="red"
              :content="cudNonLetti"
              :value="cudNonLetti && cudNonLetti > 0"
              overlap
            >
              <v-icon>mdi-text-box-outline</v-icon>
            </v-badge>
          </v-list-item-icon>
          <v-list-item-title>CU</v-list-item-title>
        </v-list-item>
        <v-list-item to="/documents">
          <v-list-item-icon>
            <v-badge
              color="red"
              :content="docsNonLetti"
              :value="docsNonLetti && docsNonLetti > 0"
              overlap
            >
              <v-icon>mdi-file-document-outline</v-icon>
            </v-badge>
          </v-list-item-icon>
          <v-list-item-title>Documenti</v-list-item-title>
          <v-list-item-action> </v-list-item-action>
        </v-list-item>
        <v-list-item to="/mynotices">
          <v-list-item-icon>
            <v-badge
              color="red"
              :content="avvisiNonLetti"
              :value="avvisiNonLetti && avvisiNonLetti > 0"
              overlap
            >
              <v-icon>mdi-view-dashboard-outline</v-icon>
            </v-badge>
          </v-list-item-icon>
          <v-list-item-title>Bacheca</v-list-item-title>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list nav dense class="list_sidebar" dark>
        <v-list-item to="/faq">
          <v-list-item-icon>
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>F.A.Q.</v-list-item-title>
        </v-list-item>
        <v-list-item to="/privacy">
          <v-list-item-icon>
            <v-icon>mdi-shield-check-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Privacy</v-list-item-title>
        </v-list-item>
        <v-list-item to="/userdata">
          <v-list-item-icon>
            <v-icon>mdi-account-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Dati account</v-list-item-title>
        </v-list-item>
        <v-list-item to="/change-password">
          <v-list-item-icon>
            <v-icon>mdi-form-textbox-password</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Password</v-list-item-title>
        </v-list-item>
        <v-list-item link @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <a :href="androidAppUrl" target="_blank">
        <v-img
          :width="logoWidth"
          :src="require('../assets/img/gplay.png')"
          class="ma-1"
        />
      </a>
      <a :href="iosAppUrl" target="_blank">
        <v-img
          :width="logoWidth"
          :src="require('../assets/img/astore.png')"
          class="ma-1"
        />
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ANDROID_APP_URL, IOS_APP_URL, colors } from "@/constants";

export default {
  name: "sidebar",
  data() {
    return {
      logoWidth: "125px",
      active: 1,
      androidAppUrl: ANDROID_APP_URL,
      iosAppUrl: IOS_APP_URL,
      colors
    };
  },
  mounted() {
    this.fetchNonLetti();
    this.fetchAvvisiNonLetti();
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "account/authenticated",
      account: "account/account",
      activeProfile: "account/activeProfile",
      bpNonLetti: "payroll/bpNonLetti",
      cudNonLetti: "cud/cudNonLetti",
      docsNonLetti: "document/docsNonLetti",
      avvisiNonLetti: "employee/avvisiNonLetti",
    }),
  },
  methods: {
    ...mapActions({
      doLogout: "account/doLogout",
      fetchNonLetti: "employee/fetchNonLetti",
      fetchAvvisiNonLetti: "employee/fetchAvvisiNonLetti",
    }),
    gotoPage(page) {
      this.$router.push(page);
    },
    logout() {
      this.doLogout();
    },
  },
};
</script>

<style>
.user-name {
  color: #fff;
  padding: 15px 0 0 15px;
}
.dim_sidebar{
  height: 95.2vh;
}
</style>
